'use strict';
import Barba from 'barba.js';
import Env from '../base/env.js';
import Grid from '../components/moods/Grid'
import GridAccordion from '../fx/Accordion'
import Focus from '../components/moods/Focus'
import Channels from '../base/channels'
import RegisterMail from '../components/RegisterMail'
import Lazyload from '../components/moods/Lazyload';
import {TweenLite, TimelineLite} from 'gsap';


let page

class Page
{
    constructor(view='')
    {
        this.view = view
        this.classView = 'currentView--moodIndex'
        // Objects
        this.$capture = this.view.querySelectorAll('.jsFocus--capture')[0]
        this.raf = undefined
        this.accordions = []
        // Fns
        this.completeLazyload = this.lazyloadIsComplete.bind(this)
        if(this.view.querySelector('.jsIsotope--view') != null) {
            this.grid = new Grid(view)
            this.grid.setup()
            // this.bandletterColor()
        }

        this.setupAccordion()
        if(this.view.querySelector('.jsFocus--view') != null) {
            this.focus = new Focus(view)
            this.focus.setup()
        }
        this.moodletter = new RegisterMail(this.view.querySelector('.jsRegister--bandletter'))
        this.events()
        // Launch Fn
        this.funcLaunch = this.intro.bind(this)
        if(Env.framework.UI.launcher.LAUNCHED == false) this.channels()
    }

    bandletterColor()
    {
        if(typeof this.$capture != 'undefined') {
            const getBg = this.$capture.style.backgroundColor
            const $bandletter = this.view.querySelector('.bandletter');
            $bandletter.style.borderColor = getBg
            $bandletter.querySelector('.h3').style.color = getBg
            $bandletter.querySelector('.description').style.color = getBg
            $bandletter.querySelector('form').style.backgroundColor = getBg

        }
    }

    createAccordions($items)
    {
        if($items.length)
        {
            for(let i = 0; i < $items.length; i++ ) {
                const $item = $items[i]
                let instance =  new GridAccordion($item)
                instance.setup()
                this.accordions.push(instance)
            }
        }
    }

    refreshAccordion()
    {


    }

    channels()
    {
        Channels.on('launcher::exit',this.funcLaunch)
    }

    destroy()
    {
        if(typeof this.grid != 'undefined') {
            this.grid.destroy()
        }
        this.lazy.destroy()
        if(typeof this.focus != "undefined") {
            this.focus.destroy()
        }
        Channels.removeListener('lazyload::finalize',this.completeLazyload)
        Channels.removeListener('launcher::exit', this.funcLaunch);
    }

    events()
    {
        Channels.on('lazyload::finalize',this.completeLazyload)

        Env.framework.UI.listenTransitionUpdateBg(this.view)
    }

    finalize()
    {
        setTimeout(() => {
            if(Env.isVisiting === true) {
                this.intro()
            }
            this.lazy = new Lazyload(this.view)
        }, 100);
        Env.framework.UI.pinRefresh()
        Env.framework.UI.lazy()
    }

    intro()
    {
        const tl = new TimelineLite()
        const $header = this.view.querySelector('.mood-index__header')
        const $focus = this.view.querySelector('.mood-index__focus')
        const $grid = this.view.querySelector('.mood-index__receptor')

        tl.add([
            TweenLite.fromTo($header , .8 , { opacity : 0 , y : 10 } , { opacity : 1 , y : 0 , ease : Power3.easeOut }),
        ])
        if($focus !== null) {
            if(Env.mobileCSS === false) {
                tl.add([
                    TweenLite.fromTo($focus , .8 , { opacity : 0 , y : 20 } , { opacity : 1 , y : 0 , ease : Power3.easeOut , delay : .1 })
                ],'-=.8')
            }
        } else {
            tl.add([
                TweenLite.fromTo($grid , .8 , { opacity : 0 , y : 20 } , { opacity : 1 , y : 0 , ease : Power3.easeOut , delay : .1 })
            ],'-=.8')
        }
    }

    lazyloadIsComplete()
    {
        const $items = this.view.querySelectorAll('.jsLazy--item:not(.jsLazy--isDone)');
        this.grid.lazyUpdate($items)
        setTimeout(() => {
            this.createAccordions($items)
            Env.framework.UI.listenTransitionUpdateBg(this.view)
            PinUtils.build()
            Env.framework.UI.lazy()
        }, 500);
    }

    setupAccordion()
    {
        const $items = this.view.querySelectorAll('.jsAccordion--item');
        this.createAccordions($items)
    }

}

page = Barba.BaseView.extend({
    namespace: 'moodIndex',
    node: undefined,
    onEnter: function() {
        this.node = new Page(this.container)
        Env.$html.classList.add(this.node.classView)
    },
    onEnterCompleted:function()
    {
        this.node.finalize()
    },
    onLeave: function()
    {
        this.node.destroy()
    },
    onLeaveCompleted: function()
    {
        if(this.container.getAttribute('data-namespace') != this.namespace)
        {
            Env.$html.classList.remove(this.node.classView)
        }
    }
});

export default page;